/** Services Import */
import { setRowData } from '../../Reducer/GridReducer';
import Commons from '../Common/Common';
import { v4 as uuidv4 } from 'uuid';

const GridFunctions = {
  // 그리드의 행이 선택되었을 때 해당 변경 함수에 선택된 행의 데이터를 저장함
  onSelectionChanged: (_ref, _saveFunc) => {
    const selected = _ref.current.api.getSelectedRows();
    _saveFunc(selected);
  },

  // 그리드의 각 셀이 변경되었을 때 호출되어 기존에 기존에 있던 데이터를 새로 변경된 데이터로 변경시킴
  onCellValueChanged: (_row, _ref, _saveFunc, _gridState, _dispatch) => {
    let defaultData = [];
    _ref.current.api.forEachNode((node) => {
      defaultData.push({ ...node.data, i: node.id });
    });

    let changeRow = defaultData.filter((f) => f.i === _row.node.id)[0];
    let changeRow2 = _ref.current.api.getDisplayedRowAtIndex(_row.rowIndex);

    if (_row.oldValue !== _row.newValue) {
      if (_gridState) {
        // redux(gridState) 사용시
        const idx = _gridState.changed.findIndex((c) => c.no === changeRow.no);
        if (idx > -1) {
          const next = [..._gridState.changed];
          next[idx] = { ...changeRow, editYn: 'Y' };
          _saveFunc(next);
        } else {
          const next = [..._gridState.changed, { ...changeRow, editYn: 'Y' }];
          _saveFunc(next);
        }

        _dispatch(
          setRowData({
            gridId: 'grid1',
            rowData: _gridState.rowData.map((row) =>
              row.no === changeRow.no ? { ...changeRow, editYn: 'Y' } : row
            ),
          })
        );
      } else {
        // useState 사용시
        _saveFunc((current) => {
          const idx = current.findIndex((c) => c.no === changeRow.no);
          if (idx > -1) {
            const next = [...current];
            next[idx] = { ...changeRow, editYn: 'Y' };
            return next;
          } else {
            return [...current, { ...changeRow, editYn: 'Y' }];
          }
        });
      }

      _ref.current.api.flashCells({
        rowNodes: [changeRow2],
      });

      changeRow2.setData({ ...changeRow, editYn: 'Y' });
    }
  },

  // 데이터에 추가된 내용이 있을 경우 (상단 함수의 newYn 변수) 배경색을 변경함.
  getRowStyle: (_row) => {
    if (_row.data !== undefined && _row.data.deleteYn === 'Y') {
      return { background: '#2CA900' };
    }
    if (_row.data !== undefined && _row.data.newYn === 'Y') {
      return { background: '#DEF7EC' };
    }
  },

  //추가 버튼 클릭 시 row 한 줄 추가
  // options.skipStartEdit === true 이면 첫 번째 셀 포커스/편집 시작 생략 (예: 추가 직후 모달을 띄우는 화면)
  addClick: (_ref, defaultNewData, options = {}) => {
    const newRow = {
      newYn: 'Y',
      no: uuidv4(),
      ...defaultNewData,
    };

    _ref.current.api.applyTransaction({
      add: [newRow],
      addIndex: 0,
    });

    if (options.skipStartEdit) return;

    setTimeout(() => {
      if (!_ref.current || !_ref.current.api) return;
      //editable true 첫번째 cell 찾기
      const firstEditableColumn = _ref.current.api
        .getColumnDefs()
        .find((col) => col.editable && !col.hide);
      //cell 있으면 해당 cell에 포커스
      if (firstEditableColumn) {
        const field = firstEditableColumn.field;

        // 1. 해당 셀에 포커스 설정
        _ref.current.api.setFocusedCell(0, field);

        // 2. 해당 셀을 편집 모드로 변경
        _ref.current.api.startEditingCell({
          rowIndex: 0,
          colKey: field,
        });
      }
    }, 0);
  },
  //폼 그리드 상태값 변경
  formGridState: (_ref, name, value, updatedInputs) => {
    _ref.current.api.forEachNode((node) => {
      if (node.data.no === updatedInputs.no) {
        node.setDataValue(name, value); // 특정 컬럼 값만 업데이트
      }
    });
    // setRowData((prev) => {
    //   const filtered = prev.filter((item) => item.no !== updatedInputs.no);
    //   return [...filtered, updatedInputs];
    // });
  },

  // 폼 그리드 다중 생성 시 상태값 변경 (정상 작동 확인 후 formGridState대신에 사용해도 됨됨)
  multiformGridState: (_ref, name, value, updatedInputs) => {
    _ref.current.api.forEachNode((node) => {
      if (node.data.tempId === updatedInputs.tempId) {
        node.setDataValue(name, value); // 특정 컬럼 값만 업데이트
      }
    });
  },

  //KEY인경우 새로운 ROW일때만 수정가능
  isCellEditable: (_params) => {
    let editable = _params.node.data.newYn === 'Y' ? true : false;
    // 기존 데이터는 id가 존재하고, 새로운 데이터는 id가 없습니다
    // id가 없는 경우 새로운 행으로 간주하여 editable을 true로 설정
    return editable;
  },
  //다음 CELL 포커스(_ref : "포커스 할 그리드",_name : 현재 CELL filed,_data: 현재 행 data)
  cellNextFocus: (_ref, _name, _data) => {
    const columnApi = _ref.current.columnApi || _ref.current.api.columnApi;

    if (columnApi) {
      const allColumns = columnApi.getAllDisplayedColumns(); // 사용 가능한 모든 컬럼 가져오기

      const currentColumn = _name; // 현재 수정한 컬럼
      const columnIndex = allColumns.findIndex(
        (col) => col.getColId() === currentColumn
      );

      if (columnIndex >= 0 && columnIndex < allColumns.length - 1) {
        const nextColumn = allColumns[columnIndex + 1].getColId();
        _ref.current.api.setFocusedCell(_data.node.rowIndex, nextColumn);
        _ref.current.api.startEditingCell({
          rowIndex: _data.node.rowIndex,
          colKey: nextColumn,
        });
      }
    }
  },

  // 그리드 행 순번 재정렬
  reorderRowNum: (changedRowData, rowData) => {
    const newRows = changedRowData.filter((row) => row.newYn === 'Y');

    const updatedMap = new Map(changedRowData.map((row) => [row.no, row]));

    const existedRows = rowData
      .filter((row) => row.newYn !== 'Y')
      .map((row) => updatedMap.get(row.no) || row);

    const reorderedNewRows = newRows.map((row, index) => ({
      ...row,
      no: index + 1,
    }));

    const reorderedExistedRows = existedRows.map((row, index) => ({
      ...row,
      no: newRows.length + index + 1,
    }));

    const result = [...reorderedNewRows, ...reorderedExistedRows];
    return result;
  },
};

export default GridFunctions;
